import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, shareReplay, switchMap } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { Apollo } from 'apollo-angular';
import searchQuery from './search.query';

@Injectable({
  providedIn: 'root',
})
export class SearchService {
  constructor(private _http: HttpClient, private apollo: Apollo) {}

  private updateData$ = new BehaviorSubject<void>(void 0);
  readonly searchData$ = this.updateData$.pipe(
    switchMap(() =>
      this.apollo.query({
        query: searchQuery,
        variables: {},
      })
    ),
    shareReplay(1)
  );

  refresh(): void {
    this.updateData$.next();
  }

  getSearchResult(searchText) {
    return this.apollo
      .query({
        query: searchQuery,
        variables: {
          search: searchText,
        },
      })
      .pipe(
        map((response) => {
          return response['data'];
        })
      )
      .pipe(shareReplay(1));
  }

  PaginationData(pageno: number, searchText, sortText) {
    if (sortText.length != 0) {
      return this.apollo
        .query({
          query: searchQuery,
          variables: {
            search: searchText,
            page: pageno,
          },
        })
        .pipe(
          map((response) => {
            return response['data'];
          })
        )
        .pipe(shareReplay(1));
    } else {
      return this.apollo
        .query({
          query: searchQuery,
          variables: {
            search: searchText,
            page: pageno,
          },
        })
        .pipe(
          map((response) => {
            return response['data'];
          })
        )
        .pipe(shareReplay(1));
    }
  }

  getSortValue(searchText, sortText) {
    return this._http
      .get(
        environment.backend.baseURL +
          '/search/?query=' +
          searchText +
          '&sort=' +
          sortText
      )
      .pipe(shareReplay(1));
  }
}
